import React, { Component, useEffect, useState } from 'react';
import { Route, Link, NavLink, withRouter } from "react-router-dom";
import MapView from './MapView';
import BookmarkButton from './BookmarkButton';
import StickyWatcher from './StickyWatcher';
import _ from 'underscore';

import config from './../config';
import helpers from './../utils/helpers';


class NofnIslendingaSearchResults extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/nofn_islendinga/greinar/';

		this.state = {
			data: []
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.match.params.nafn != prevProps.match.params.nafn
		) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			notFound: false,
			fetching: true
		});

		let urlParams = [];

		urlParams.push('limit='+config.pageSize);

		if (this.props.match.params.nafn) {
			urlParams.push('q='+this.props.match.params.nafn)
		}

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				if (json.results.length == 1) {
					this.props.history.replace('/nofnislendinga/'+json.results[0].id)
				}
				else {
					this.setState({
						data: json.results,
						notFound: json.results.length == 0,
						fetching: false,
						nextUrl: json.next,
						previousUrl: json.previous,
						resultsCount: json.count
					});
					if (this.props.onResults) {
						this.props.onResults(json);
					}
				}
			}.bind(this));
	}

	htmlContentClickHandler(event) {
		let linkEl = event.target.closest('a');

		let isExternal = (url) => {
			var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
			if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== window.location.protocol) return true;
			if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[window.location.protocol]+")?$"), "") !== window.location.host) return true;
			return false;
		}

		if (linkEl) {
			let linkUrl = linkEl.getAttribute('href');

			if (linkUrl) {
				if (!isExternal(linkUrl) && (!linkEl.getAttribute('target'))) {
					event.preventDefault();

					console.log('go to: '+linkUrl);

					this.props.history.push('/nofnislendinga/'+linkUrl)
				}
			}
		}
	}

	render() {
		return (
			<React.Fragment>
				<div className={'row boxes'+(this.state.maximizeResults ? ' maximize-results' : '')}>

					<div className={'results-column col col-12 col-md-9'}>
						<div className="column-content no-padding">
							<div className="tabs-wrapper">
								<StickyWatcher className="column-heading sticky" useBodyTag={false} stickyClassName="is-sticky">
									<strong>Leitarniðurstöður</strong>

									<ul className="nav nav-tabs">
										<li className="nav-item">
											<div className={'nav-link active'}>Nöfn íslendinga</div>
										</li>
									</ul>
								</StickyWatcher>

								<div className="tabs-content padding-25">

									<div className="tab visible">

										{
											this.state.notFound &&
											<tr><td colSpan="3" className="text-center">Ekkert fannst</td></tr>
										}

										<table className={'table table-responsive'+(this.state.fetching ? ' loading' : '')}>
											<thead>
												<tr>
													<th>Nafn</th>
												</tr>
											</thead>
											<tbody>
												{
													this.state.data.map((item, index) => <tr key={index}>
														<td>
															<Link to={'/nofnislendinga/'+item.id}><span dangerouslySetInnerHTML={{__html: item.nafn.map((n, i) => i > 0 ? '<i>'+n.nafn+'</i>' : '<strong>'+n.nafn+'</strong>').join(', ')+(item.nafn[0].ofl ? ' <small>'+item.nafn[0].ofl+'</small>' : '')+(item.nafn[0].beyging ? ' <small><i>('+item.nafn[0].beyging+')</i></small>' : '')}} /></Link>
															{
																item.texti && <div onClick={this.htmlContentClickHandler.bind(this)} dangerouslySetInnerHTML={{__html: item.texti.replace('\n', '<br/>') }} />
															}
														</td>
													</tr>)
												}
											</tbody>
										</table>
									
									</div>

								</div>
							</div>
						</div>
					</div>

				</div>
			</React.Fragment>
		);
	}
}

export default withRouter(NofnIslendingaSearchResults);



// WEBPACK FOOTER //
// ./src/components/NofnIslendingaSearchResults.js